export default function SnowEffect() {
	// Generate random snowflakes
	const snowflakes = Array.from({ length: 50 }).map((_, i) => ({
		id: i,
		left: `${Math.random() * 100}vw`,
		animationDuration: `${Math.random() * 3 + 2}s`,
		animationDelay: `${Math.random() * 2}s`,
		opacity: Math.random(),
		size: `${Math.random() * 10 + 5}px`,
	}))

	return (
		<div className='fixed inset-0 pointer-events-none z-50 overflow-hidden'>
			<style>
				{`
          @keyframes fall {
            0% {
              transform: translateY(-10vh) translateX(0);
            }
            100% {
              transform: translateY(110vh) translateX(20px);
            }
          }
        `}
			</style>
			{snowflakes.map((flake) => (
				<div
					key={flake.id}
					className='absolute bg-white rounded-full'
					style={{
						left: flake.left,
						top: -20,
						width: flake.size,
						height: flake.size,
						opacity: flake.opacity,
						animation: `fall ${flake.animationDuration} linear infinite`,
						animationDelay: flake.animationDelay,
					}}
				/>
			))}
		</div>
	)
}
